<div class="row">
	<div class="col-sm">
		<div class="card w-100">
			<div class="card-header">
				<div class="row">
					<div class="col">Edit Phases</div>
				</div>
			</div>
			<div class="card-body p-0">
				<ag-grid-angular
					style="width: 100%; height: 200px"
					class="ag-theme-alpine"
					[columnDefs]="columnDefsPhases"
					[rowData]="rowDataPhases"
					(cellValueChanged)="onCellValueChangedPhase($event)"
					(gridReady)="onGridReadyPhase($event)"
				>
				</ag-grid-angular>

				<ag-grid-angular
					style="width: 100%; height: 900px"
					class="ag-theme-alpine"
					[columnDefs]="columnDefs"
					[rowData]="rowData"
					(cellValueChanged)="onCellValueChanged($event)"
					(gridReady)="onGridReady($event)"
				>
				</ag-grid-angular>
			</div>
		</div>
	</div>
</div>
